module.exports = __webpack_public_path__ + "static/media/paint_medium.06196327.jpg";